import {initWorkQuizFirstTab} from './work-quiz';

/** Не трогаем блок фильтра по номинациям на странице списка заявок организатора (.works-filter-nominations-root). */
function isContestWorksFilterNominationEl(el) {
  return !!(el && el.closest('.works-filter-nominations-root'));
}

let baseNominations, baseNominationsInputs, subNominations;
let selectedNominations, workFields, workSeparators;
let tabs, contents, tabName;

function syncNominationChevrons() {
  if (!baseNominations?.length) {
    return;
  }
  baseNominations.forEach((baseLi) => {
    const sub = baseLi.querySelector('ul.sub-nominations');
    const chevron = baseLi.querySelector('.nomination-expand-chevron');
    if (!sub || !chevron) {
      return;
    }
    const open = window.getComputedStyle(sub).display !== 'none';
    chevron.classList.toggle('fa-chevron-down', !open);
    chevron.classList.toggle('fa-chevron-up', open);
  });
}

function parseFieldNominations(field) {
  const raw = field.dataset.fieldNomination;

  if (!raw) {
    return [0];
  }

  try {
    const parsed = JSON.parse(raw);

    return Array.isArray(parsed) ? parsed : [0];
  } catch {
    return [0];
  }
}

function handleNominationChange(selectedNominationId) {
  if (!selectedNominationId) {
    return;
  }

  let selectedNomination = document.querySelector('.selected_nomination:checked[value="' + selectedNominationId + '"]');

  if (!selectedNomination) {
    selectedNomination = document.querySelector('.selected_nomination[value="' + selectedNominationId + '"]');
  }

  if (!selectedNomination) {
    applyNominationVisibility(parseInt(selectedNominationId, 10));
    return;
  }

  const selectedNominationParent = selectedNomination.closest('.base-nomination');
  const selectedSubnomination = selectedNominationParent?.querySelector('.selected_nomination:checked[data-parent-id="' + selectedNomination.value + '"]');

  if (selectedSubnomination) {
    selectedNominationId = selectedSubnomination.value;
  }

  applyNominationVisibility(parseInt(selectedNominationId, 10));
}

function refreshWorkFieldNodes() {
  workFields = document.querySelectorAll('.custom_work_field');
  workSeparators = document.querySelectorAll('.custom_work_field_separator');
}

function applyNominationVisibility(selectedNominationId) {
  if (!Number.isFinite(selectedNominationId)) {
    return;
  }

  refreshWorkFieldNodes();

  workFields.forEach((field) => {
    let fieldNominations = parseFieldNominations(field);

    // проверка если есть и нули, и другие числа
    let fieldNominationNotZero = fieldNominations.some(item => item !== 0) // true, если есть числа, отличные от нуля

    if (fieldNominationNotZero) {
      fieldNominations = fieldNominations.filter(number => number !== 0)
    }

    let display;

    const shouldShow = fieldNominations.includes(selectedNominationId) || fieldNominations.includes(0);

    field.classList.toggle('is-hidden-by-nomination', !shouldShow);
    field.style.display = shouldShow ? '' : 'none';
  });

  workSeparators.forEach((field) => {
    let fieldNominations = parseFieldNominations(field);

    // проверка если есть и нули, и другие числа
    let fieldNominationNotZero = fieldNominations.some(item => item !== 0) // true, если есть числа, отличные от нуля
    if (fieldNominationNotZero) {
      fieldNominations = fieldNominations.filter(number => number !== 0)
    }

    const shouldShow = fieldNominations.includes(selectedNominationId) || fieldNominations.includes(0);

    field.classList.toggle('is-hidden-by-nomination', !shouldShow);
    field.style.display = shouldShow ? '' : 'none';
  });
}

function initShowSelectedNominationsFields() {
  selectedNominations = document.querySelectorAll('.selected_nomination');
  refreshWorkFieldNodes();

  const nominationForm = document.querySelector('.application-form') || document;

  if (nominationForm.dataset.nominationVisibilityBound !== '1') {
    nominationForm.dataset.nominationVisibilityBound = '1';
    nominationForm.addEventListener('change', (event) => {
      const target = event.target;

      if (!(target instanceof HTMLInputElement) || !target.classList.contains('selected_nomination')) {
        return;
      }

      handleNominationChange(target.value);
    });
  }

  // при загрузке страницы выбираем еще раз номинацию, чтобы скрыть ненужные поля
  let selectedNomination = document.querySelector('.selected_nomination:checked');

  if (selectedNomination) {
    const selectedNominationParent = selectedNomination.closest('.base-nomination');
    const selectedSubnomination = selectedNominationParent?.querySelector(
      '.selected_nomination:checked[data-parent-id="' + selectedNomination.value + '"]'
    );

    if (selectedSubnomination) {
      selectedNomination = selectedSubnomination;
    }
  }

  if (!selectedNomination && selectedNominations.length > 0) {
    selectedNomination = selectedNominations[0];
    selectedNomination.checked = true;
  }

  if (selectedNomination) {
    handleNominationChange(selectedNomination.value);
  }
}

function initNominations() {
  // Скрываем все подноминации при загрузке страницы
  subNominations?.forEach(subNomination => {
    subNomination.style.display = 'none';
  });

  // Открываем первую подноминацию, если нет выбранных подноминаций или номинаций
  let selectedNomination = document.querySelector('.selected_nomination:checked');

  if (!selectedNomination && baseNominations.length > 0) {
    const firstBaseNomination = baseNominations[0];
    const firstSubNomination = firstBaseNomination.querySelector('ul.sub-nominations');
    let firstBaseNominationInput;

    if (firstSubNomination) {
      firstBaseNominationInput = firstBaseNomination.querySelector('input[name="category_parent"]');
    } else {
      firstBaseNominationInput = firstBaseNomination.querySelector('input[name="category"]');
    }

    const firstSubNominationInput = firstSubNomination?.querySelector('input[name="category"]');

    if (firstSubNomination) {
      firstSubNomination.style.display = 'block';
      firstBaseNominationInput.checked = true;
      firstSubNominationInput.checked = true;
    } else {
      firstBaseNominationInput.checked = true;
    }
  } else if (selectedNomination) {
    // Открываем подноминацию, если выбрана подноминация
    const parentBaseNomination = selectedNomination.closest('.base-nomination');
    const parentSubNomination = parentBaseNomination.querySelector('ul.sub-nominations');

    if (parentSubNomination) {
      parentSubNomination.style.display = 'block';
    }
  }
  syncNominationChevrons();
}

export default function() {
  baseNominations = [...document.querySelectorAll('.base-nomination')].filter(
    (el) => !isContestWorksFilterNominationEl(el)
  );
  baseNominationsInputs = document.querySelectorAll('.base-nomination-input');

  if (!baseNominations.length) {
    return;
  }

  subNominations = [...document.querySelectorAll('ul.sub-nominations')].filter(
    (el) => !isContestWorksFilterNominationEl(el)
  );
  initNominations();

  baseNominationsInputs.forEach((baseNominationInput) => {
    baseNominationInput.addEventListener('click', () => {
      baseNominationsInputs?.forEach((baseInput) => {
        baseInput.checked = false;
      });

      baseNominationInput.checked = true;
      document.querySelectorAll('ul.sub-nominations').forEach((subNomination) => {
        if (isContestWorksFilterNominationEl(subNomination)) {
          return;
        }
        subNomination.style.display = 'none';
      });
      const baseNominationInputParent = baseNominationInput.closest('li.base-nomination');
      const currentSubNominations = baseNominationInputParent.querySelector('ul.sub-nominations');
      let selectedNominationId = null;

      if (currentSubNominations) {
        currentSubNominations.style.display = 'block';
        const currentSubNominationsInputs = currentSubNominations.querySelectorAll('input[name="category"]');
        const currentCheckedSubNominationInput = currentSubNominations.querySelector('input[name="category"]:checked');

        if (!currentCheckedSubNominationInput && currentSubNominationsInputs.length) {
          currentSubNominationsInputs[0].checked = true;
        }

        const activeSubNomination = currentSubNominations.querySelector('input[name="category"]:checked');
        if (activeSubNomination) {
          selectedNominationId = activeSubNomination.value;
        }
      } else {
        const categoryInput = baseNominationInputParent?.querySelector('input[name="category"]:checked')
          || baseNominationInputParent?.querySelector('input[name="category"]');
        if (categoryInput) {
          categoryInput.checked = true;
          selectedNominationId = categoryInput.value;
        }
      }

      if (selectedNominationId) {
        handleNominationChange(selectedNominationId);
      } else if (baseNominationInput.value) {
        handleNominationChange(baseNominationInput.value);
      }
      syncNominationChevrons();
    });
  });

  document.querySelectorAll('.sub-nomination-input').forEach((subNominationInput) => {
    subNominationInput.addEventListener('click', () => {
      if (subNominationInput.value) {
        handleNominationChange(subNominationInput.value);
      }
    });
  });

  initShowSelectedNominationsFields();

  tabs = document.querySelectorAll(".quiz-steps__tab");
  contents = document.querySelectorAll("[data-quiz-uuid]");
  tabName = document.querySelectorAll(".quiz-steps__tab-name");

  // Устанавливаем первый таб активным и отображаем его контент
  if (tabs.length > 0 && contents.length > 0) {
    initWorkQuizFirstTab()
  }
}